import { spacing } from "@indeed/ifl-tokens/react-native";
import React from "react";

import { Flex, Heading } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";
import { IndeedProIcon } from "../../../lib/IndeedProIcon";
import { EmployerInsightsPopover } from "./EmployerInsightsPopover";

export function PremiumHeader() {
  const i18n = useI18n();

  return (
    <Flex
      sx={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Flex sx={{ flexDirection: "column" }}>
        <Flex
          sx={{
            flexDirection: "row",
            gap: spacing.s1,
          }}
        >
          <IndeedProIcon width={20} height={20} />
          <Heading level={2}>{i18n.gettext("Indeed Pro")}</Heading>
        </Flex>
      </Flex>
      <EmployerInsightsPopover />
    </Flex>
  );
}
